export default __webpack_public_path__ + "static/media/screenBlock2.6e473d81.jpg";